import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-notification-engine',
  templateUrl: './notification-engine.component.html',
  styleUrls: ['./notification-engine.component.scss'],
})
export class NotificationEngineComponent {
  constructor() {}
}

